'use client';

import { Heading, LayoutContainer, LinkList, LinkListItem, TextPassage } from '@petsmart-ui/sparky';
import cn from 'classnames';

import { FaqSeo } from '@libs/common-next';
import { Accordion } from '@libs/shared-ui/components/Accordion';

import { parseRichContentToPlainText, parseRichText } from '../../utils/parseRichText';
import { useItems } from '../../utils/useItems';
import { FaqStoreCards } from './FaqStoreCards';
import type { FaqProps } from './types';
import './Faq.scss';

export default function Faq({ variant, headline, subHeader, lineItem }: FaqProps) {
    const faqItems = useItems(lineItem, variant);
    const panelClassnames = cn({ 'faq-question': variant === 'FAQ' });
    const containerClassName = cn('faq', {
        'faq-centered': variant === 'Store Cards',
    });
    return (
        <LayoutContainer className="sparky-u-width-100">
            <div className={containerClassName}>
                <Heading size="title" tagName="h2">
                    {headline}
                </Heading>

                {subHeader && <TextPassage className="faq-subheader">{subHeader}</TextPassage>}

                <div className="faq-accordions">
                    {faqItems.map(items => (
                        <div className="faq-accordion-group" key={items.at(0)?.sysId}>
                            <Accordion
                                items={items.map(group => ({
                                    id: group.sysId,
                                    title: group.question,
                                    className: panelClassnames,
                                    children: (
                                        <LinkList
                                            className={cn('faq-list', {
                                                'faq-list-cards': variant === 'Store Cards',
                                            })}
                                        >
                                            {variant === 'Columns' &&
                                                group.answers.map(a => (
                                                    <LinkListItem
                                                        key={a.sysId}
                                                        text={a.actionText}
                                                        href={a.link.webUrl}
                                                    />
                                                ))}
                                            {variant === 'FAQ' && parseRichText(group.answer)}
                                            {variant === 'Store Cards' && group?.storeCards && (
                                                <FaqStoreCards key={group.sysId} answers={group.storeCards} />
                                            )}
                                        </LinkList>
                                    ),
                                }))}
                            />
                            <FaqSeo
                                id="faq-seo"
                                qaArray={items.map(item => ({
                                    question: item.question,
                                    answer: parseRichContentToPlainText(item.answer),
                                }))}
                            />
                        </div>
                    ))}
                </div>
            </div>
        </LayoutContainer>
    );
}
